import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data";

function selectService(id) {
  window.dispatchEvent(new CustomEvent("prefill-service", { detail: id }));
  const el = document.querySelector("#book");
  if (el) el.scrollIntoView({ behavior: "smooth" });
}

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};
const item = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export default function Services() {
  return (
    <section id="services" className="py-24 sm:py-32 scroll-mt-20 bg-background">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-accent font-bold text-sm tracking-widest uppercase">Our Services</span>
            <h2 className="font-display font-extrabold text-4xl sm:text-6xl mt-3 tracking-tight text-primary max-w-xl">
              Paw-some care for every occasion
            </h2>
          </div>
        </div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6"
        >
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const featured = i < 2;
            return (
              <motion.article
                key={s.id}
                variants={item}
                data-testid={`service-card-${s.id}`}
                className={`group relative overflow-hidden rounded-3xl bg-card border border-black/5 shadow-[0_12px_40px_-18px_rgba(93,87,107,0.3)] hover:shadow-[0_20px_50px_-15px_rgba(93,87,107,0.4)] transition-all duration-300 hover:-translate-y-1.5 ${
                  featured ? "lg:col-span-3" : "lg:col-span-2"
                }`}
              >
                <div className={`relative ${featured ? "h-64 sm:h-72" : "h-52"} overflow-hidden bg-muted`}>
                  <img
                    src={s.image}
                    alt={s.name}
                    loading="eager"
                    decoding="async"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-4 py-1.5 text-sm font-bold text-primary shadow-sm">
                    {s.tag}
                  </span>
                  <span
                    data-testid={`service-price-${s.id}`}
                    className="absolute bottom-4 left-4 rounded-full bg-accent px-4 py-1.5 text-sm font-extrabold text-accent-foreground shadow-sm"
                  >
                    {s.price}
                  </span>
                </div>

                <div className="p-7">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="grid place-items-center h-11 w-11 rounded-2xl bg-secondary/40 text-primary">
                      <Icon size={20} />
                    </span>
                    <h3 className="font-display font-extrabold text-2xl text-primary">{s.name}</h3>
                  </div>
                  <p className="text-muted-foreground text-base leading-relaxed mb-6 max-w-md font-medium">
                    {s.desc}
                  </p>
                  <button
                    onClick={() => selectService(s.id)}
                    data-testid={`service-book-${s.id}`}
                    className="inline-flex items-center gap-2 text-sm font-bold text-primary group/btn"
                  >
                    <span className="border-b-2 border-accent/40 group-hover/btn:border-accent pb-0.5 transition-colors">
                      Request a booking
                    </span>
                    <ArrowUpRight size={16} className="text-accent group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform" />
                  </button>
                </div>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
